export default "__VITE_ASSET__Ch2yJ1dj__"